<div>
  <app-header [class.disableEvents]="disableSection && !showCompleteOrTerminateToast"
    (openPartnerCompleteOrTerminateDialog)="openPartnerCompleteOrTerminateDialog()" (openDiscardConsentDialog)="openExitConsentDialog('header')"  (showHideMenu)="showHideMenu()"
    [isShowMenu]="mobileQuery.matches">
  </app-header>
  <mat-drawer-container class="upload-container" fullscreen>
    <mat-drawer [mode]="mobileQuery.matches ? 'over' : 'side'" [fixedInViewport]="mobileQuery.matches"
      [opened]="(!mobileQuery.matches) || (mobileQuery.matches && opened)"
      [position]="mobileQuery.matches ? 'end' : 'start'"
      [class.disableEvents]="disableSection && !showCompleteOrTerminateToast" [disableClose]="true" #sidenav>
      <mat-nav-list class="menu-list">
        @if (mobileQuery.matches) {
          <div class="user-info-section">
            <mat-icon class="mat-icon-large">account_circle</mat-icon>
            <div class="user-info">
              <span class="user-name">{{userInfo && userInfo.username | titlecase}}</span>
              <span class="user-name">{{userInfo && userInfo.email}}</span>
            </div>
          </div>
        }
        @if (isAuthorizedUser('Partner Onboarding', 'User Account Creation', 'Custom Field Update')) {
          <mat-expansion-panel class="dropdown-group" [expanded]="accountManagement">
            <mat-expansion-panel-header class="dropdown-header">
              <mat-panel-title class="dropdown-title">
                <mat-icon class="dropdown-icon">account_box</mat-icon>
                <a>Account Management</a>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-nav-list class="sub-menu-list">
              @if (isAuthorizedUser('Partner Onboarding')) {
                <mat-list-item  #partner class="menu-item menu-sub-item" (click)="goToPage('partner')"
                  [ngClass]="{'selected': activePage === 'partner'}">
                  <svg _ngcontent-yyv-c7="" height="24" viewBox="0 0 20.864 14.71" width="24"
                    xmlns="http://www.w3.org/2000/svg" class="ng-star-inserted">
                    <g _ngcontent-yyv-c7="" data-name="Group 4317" id="Group_4317"
                      transform="translate(-23 -344.924)">
                      <path _ngcontent-yyv-c7=""
                        d="M14.854,289.763H12.959l-.069.208a.741.741,0,0,0,.18.763l1.995,1.995a2.622,2.622,0,0,0,1.019.63l2.81.937a2.608,2.608,0,0,0,1.15.1l-4.678-4.432A.743.743,0,0,0,14.854,289.763Z"
                        data-name="Path 3392" fill="#97999b" id="Path_3392"
                      transform="translate(10.682 64.103)"></path>
                      <path _ngcontent-yyv-c7=""
                        d="M13.926,100.359a.749.749,0,0,0-.147-.179l-2.9-2.581a.743.743,0,0,0-.5-.188h-1.3l-1.094.872a1.487,1.487,0,0,1-2.2-1.923l.209-.348-1.6.2a4.458,4.458,0,0,1-1.355-.038L.439,95.7a.364.364,0,0,0-.306.081A.368.368,0,0,0,0,96.068v6.559A.373.373,0,0,0,.372,103H2.535a1.485,1.485,0,0,1,1.025.408l6.014,5.7a1.482,1.482,0,0,0,1.353.37l-1.544-2.161a.373.373,0,0,1,.607-.433l1.715,2.4,1.6-.4-2.074-3.456a.373.373,0,1,1,.639-.383l2.174,3.623a3.7,3.7,0,0,0,.942-.53l.682-.53-2.943-4.783a.373.373,0,1,1,.635-.39l2.9,4.713.105-.082a1.494,1.494,0,0,0,.37-1.932Z"
                        data-name="Path 3393" fill="#97999b" id="Path_3393" transform="translate(23 250.121)">
                      </path>
                      <path _ngcontent-yyv-c7=""
                        d="M166.86,77.608a.372.372,0,0,0-.406-.371l-1.9.172a3.345,3.345,0,0,1-2.651-.945l-1.132-.794a1.119,1.119,0,0,0-.142-.085l-.042-.024-1-.677a4.083,4.083,0,0,0-2.291-.7h-3.251a.744.744,0,0,0-.62.332l-.4.6s0,.005,0,.008l-.6,1a.733.733,0,0,0,.191.969.746.746,0,0,0,.911-.013l1.055-.841v-.566a.373.373,0,0,1,.745,0v.373h1.054a1.489,1.489,0,0,1,.99.376L160.27,79a1.492,1.492,0,0,1,.295.358l2.807,4.772v0l3.033-1.08a.738.738,0,0,0,.455-.687Z"
                        data-name="Path 3394" fill="#97999b" id="Path_3394"
                      transform="translate(-122.996 270.74)"></path>
                    </g>
                  </svg>
                  <a>Partner Onboarding</a>
                </mat-list-item>
              }
              @if (isAuthorizedUser('User Account Creation')) {
                <mat-list-item  #customer class="menu-item menu-sub-item" (click)="goToPage('customer')"
                  [ngClass]="{'selected': activePage === 'customer'}">
                  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path fill="#97999b"
                      d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
                  </svg>
                  <a>User Account Creation</a>
                </mat-list-item>
              }
              @if (isAuthorizedUser('Customer Creation')) {
                <mat-list-item  #customer class="menu-item menu-sub-item" (click)="goToPage('customer-creation')"
                  [ngClass]="{'selected': activePage === 'customer-creation'}">
                  <mat-icon>person</mat-icon>
                  <a>Customer Creation</a>
                </mat-list-item>
              }
              @if (isAuthorizedUser('Custom Field Update')) {
                <mat-list-item class="menu-item menu-sub-item" [ngClass]="{'selected': activePage === 'customFields'}"
                  (click)="goToPage('customFields')">
                  <mat-icon>extension</mat-icon>
                  <a>Custom Fields</a>
                </mat-list-item>
              }
            </mat-nav-list>
          </mat-expansion-panel>
        }

        @if (isAuthorizedUser('PB Update')) {
          <mat-expansion-panel #bulkUpload class="dropdown-group" [expanded]="isBulkUpdate">
            <mat-expansion-panel-header class="dropdown-header">
              <mat-panel-title class="dropdown-title">
                <mat-icon class="dropdown-icon">monetization_on</mat-icon>
                <a>Billing Management</a>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-nav-list class="sub-menu-list">
              <mat-expansion-panel class="dropdown-group" [expanded]="isPricebook">
                <mat-expansion-panel-header class="dropdown-header">
                  <mat-panel-title class="dropdown-title">
                    <mat-icon class="dropdown-icon">local_offer</mat-icon>
                    <a>Price Book</a>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-nav-list class="sub-sub-menu-list">
                  <mat-list-item class="menu-item menu-sub-item" [ngClass]="{'selected': activePage === 'PriceBookpartner'}"
                    (click)="goToPage('partner-priceBook')">
                    <mat-icon>business</mat-icon>
                    <a>Partner - Cloud Account</a>
                  </mat-list-item>
                  <mat-list-item class="menu-item menu-sub-item" [ngClass]="{'selected': activePage === 'customer-priceBook'}"
                    (click)="goToPage('customer-priceBook')">
                    <mat-icon>account_circle</mat-icon>
                    <a>End Customer - Cloud Account</a>
                  </mat-list-item>
                  <mat-list-item class="menu-item menu-sub-item" [ngClass]="{'selected': activePage === 'priceBook-recreation'}"
                    (click)="goToPage('priceBook-recreation')">
                    <mat-icon>autorenew</mat-icon>
                    <a>Price Book Recreation</a>
                  </mat-list-item>
                  <mat-list-item class="menu-item menu-sub-item" [ngClass]="{'selected': activePage === 'priceBook-sku-adjustments'}"
                    (click)="goToPage('priceBook-sku-adjustments')">
                    <mat-icon>tune</mat-icon>
                    <a>Price Book - SKU Adjustments</a>
                  </mat-list-item>
                  <mat-list-item class="menu-item menu-sub-item" [ngClass]="{'selected': activePage === 'partner-priceBook-mapping'}"
                    (click)="goToPage('partner-priceBook-mapping')">
                    <mat-icon>link</mat-icon>
                    <a>Partner - Price Book Mapping</a>
                  </mat-list-item>
                </mat-nav-list>
              </mat-expansion-panel>
            </mat-nav-list>
          </mat-expansion-panel>
        }
        @if (isAuthorizedUser('Partner Onboarding', 'User Account Creation', 'Custom Field Update', 'PB Update')) {
          <mat-list-item  #history class="menu-item" (click)="goToPage('migration')"
            [ngClass]="{'selected': activePage === 'migration'}">
            <mat-icon>view_list</mat-icon>
            <a style="color: rgba(0,0,0,0.87);">Transaction History</a>
          </mat-list-item>
        }
        @if (isAuthorizedUser('Product Catalog')) {
          <mat-expansion-panel class="dropdown-group" [expanded]="isCatalogManagement">
            <mat-expansion-panel-header class="dropdown-header">
              <mat-panel-title class="dropdown-title">
                <mat-icon class="dropdown-icon">library_books</mat-icon>
                <a>Catalog Management</a>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-nav-list class="sub-menu-list">
              <!-- <mat-list-item class="menu-item menu-sub-item" (click)="goToPage('catalogDashboard')"
              [ngClass]="{'selected': activePage === 'catalogDashboard'}">
              <mat-icon>dashboard</mat-icon>
              <a>Dashboard</a>
            </mat-list-item>
            <mat-list-item class="menu-item menu-sub-item" (click)="goToPage('MyProducts')"
              [ngClass]="{'selected': activePage === 'MyProducts'}">
              <mat-icon>store</mat-icon>
              <a>My Products</a>
            </mat-list-item> -->
            <mat-list-item class="menu-item menu-sub-item" (click)="goToPage('catalogImports')"
              [ngClass]="{'selected': activePage === 'catalogImports'}">
              <mat-icon>cloud_download</mat-icon>
              <a>Import Products</a>
            </mat-list-item>
            <mat-list-item class="menu-item menu-sub-item" (click)="goToPage('productInventory')"
              [ngClass]="{'selected': activePage === 'productInventory'}">
              <mat-icon>inventory</mat-icon>
              <a>Product Inventory</a>
            </mat-list-item>
            <mat-list-item class="menu-item menu-sub-item" (click)="goToPage('syncAccount')"
              [ngClass]="{'selected': activePage === 'syncAccount'}">
              <mat-icon>sync_alt</mat-icon>
              <a>Sync Products</a>
            </mat-list-item>
          </mat-nav-list>
        </mat-expansion-panel>
      }
      @if (mobileQuery.matches) {
        <mat-list-item class="menu-item" [ngClass]="{'selected': activePage === 'logout'}"
          (click)="logout()">
          <mat-icon>power_settings_new</mat-icon>
          <a>Logout</a>
        </mat-list-item>
      }
    </mat-nav-list>
  </mat-drawer>
  <mat-drawer-content [style.overflow-y]="isSettingsPage || isBulkUpdate || isPricebook ? 'auto': 'hidden'">
    <main class="main">
      <ng-content></ng-content>
    </main>
  </mat-drawer-content>
</mat-drawer-container>
</div>

<ng-template #partnerCompleteOrTerminateDialog>
  <h2 mat-dialog-title>Information</h2>
  <div mat-dialog-content>
    Please perform the <span>{{showCompleteOrTerminateToast}}</span> action to initiate the further migration or
    explore into other features.
  </div>
  <div mat-dialog-actions>
    <button mat-button mat-dialog-close>Ok</button>
  </div>
</ng-template>

<ng-template #exitConsentDialog>
  <h2 mat-dialog-title>Discard Changes?</h2>
  <div mat-dialog-content>
    You have unsaved changes. Would you like to discard the changes before navigating away from the page?
  </div>
  <div mat-dialog-actions class="action-btn">
    <button mat-button class="next-btn" (click)="onDiscard()">Discard Changes</button>
    <button mat-button class="next-btn" mat-dialog-close>Continue Editing</button>
  </div>
</ng-template>